<template>
  <span>
    <v-row class="canvas__wrapper">
      <canvas id="the-canvas"></canvas>
    </v-row>
    <v-container id="printedContainer" class="featuresList__container ma-2">
      <v-row fluid>
        <v-col cols="auto">
          <img width="300" :src="require('@/assets/logo_txtwhite_bggreen.jpg')" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="features__wrapper">
          <template v-for="clusteredFeature in clusteredFeatures">
            <v-row :key="clusteredFeature.name" class="featureList__row--outter">
              <v-col cols="2" style="border-right: 1px solid #808080">
                <v-row class="featureList__row--inner justify-center fill-height" style="height: 100%">
                  <v-col cols="auto">
                    <img
                      width="110"
                      height="145"
                      class="featureList__img"
                      :src="require(`@/assets/marker_clustered.png`)"
                    />
                  </v-col>
                  <v-col cols="auto" class="featureList__col--clustered accentColor">
                    <span>{{ clusteredFeature.name }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="featureList__col--features py-0" cols="10">
                <template v-for="group in clusteredFeature.features">
                  <v-row v-for="feature in group.features" :key="feature.name">
                    <v-col class="featureList__col--description">
                      <span>{{ getFeatureDescription(feature) }}</span>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </template>
          <template v-for="group in filteredPrintedFeaturesGroups">
            <v-row
              v-for="(feature, index) in group.features"
              :key="feature.name"
              class="align-center featureList__row--outter"
            >
              <v-col cols="2" style="border-right: 1px solid #808080">
                <v-row class="featureList__row--inner justify-center">
                  <v-col cols="auto">
                    <img
                      width="110"
                      height="145"
                      class="featureList__img"
                      :src="require(`@/assets/marker_${group.color_name}.png`)"
                    />
                  </v-col>
                  <v-col cols="auto" class="featureList__col--sign" :style="{ color: group.color }">
                    <span>{{ String(index + 1).padStart(2, '0') }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="featureList__col--description" cols="10">
                <span>{{ getFeatureDescription(feature) }}</span>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </span>
</template>
<script>
export default {
  props: {
    clusteredFeatures: {
      type: Array,
      default: () => {
        return [];
      }
    },
    printedFeaturesProperties: {
      type: Object,
      default: () => {
        return {};
      }
    },
    printedLayerName: {
      type: String,
      required: true
    }
  },
  computed: {
    filteredPrintedFeaturesGroups() {
      const filteredKeys = {};
      Object.keys(this.printedFeaturesProperties).forEach(key => {
        if (this.printedFeaturesProperties[key].features.length > 0) {
          filteredKeys[key] = this.printedFeaturesProperties[key];
        }
      });
      return filteredKeys;
    }
  },
  methods: {
    getFeatureDescription(feature) {
      const area = this.printedLayerName === 'offers' ? feature.pow_dziaki : feature.powierzchnia;
      const name =
        this.printedLayerName === 'offers' ? feature.nazwa_nieruchomosci[this.$i18n.locale] : feature.nr_ew_dzialek;
      if (!area) {
        return `${name ? name : this.$i18n.t('default.noNameText')}`;
      }
      return `${name ? name : this.$i18n.t('default.noNameText')}, ${this.$i18n.t('default.about')} ${area} ha`;
    }
  }
};
</script>
<style lang="scss" scoped>
.canvas__wrapper {
  position: absolute;
  left: 200vw;
  top: 500vh;
}
.accentColor{
  color: var(--v-accent-base);
}
.featuresList__container {
  position: absolute;
  top: 100vh;
  left: 100vw;
  .featureList__row--outter {
    border: 2px solid #808080;
    .featureList__col--description {
      font-size: 45px;
    }
    .featureList__col--features > .row:not(:last-child) {
      border-bottom: 1px solid #808080;
    }
    .featureList__row--inner {
      position: relative;
      align-items: center;

      .featureList__col--clustered {
        position: absolute;
        font-size: 60px;
        padding-bottom: 70px;
      }
      .featureList__col--sign {
        position: absolute;
        padding-bottom: 70px;
        font-size: 53px;
      }
    }
  }
  .features__wrapper > .featureList__row--outter:not(:last-child) {
    border-bottom: none;
  }
}
</style>